import React from "react"

// antd
import {
  Typography,
  Button,
  message,
  Drawer,
  Divider,
  Form,
  Input,
  Collapse,
} from "antd"

// firebase
import { Firestore } from "services/firebase"
import { doc, updateDoc } from "firebase/firestore"

// store
import { useAuth } from "store/auth"
import { useTranslation } from "react-i18next"
import { ArrowLeftOutlined } from "@ant-design/icons"

const MenuDrawerAccount = ({ onClose, open }) => {
  const { isAuthentificated, user, setUser } = useAuth()
  const { t } = useTranslation()
  const [messageApi, contextHolder] = message.useMessage()

  const [state, setState] = React.useState("idle")
  const [formUser] = Form.useForm()
  const [formDeliveryAddress] = Form.useForm()

  React.useEffect(() => {
    if (!isAuthentificated || !open) return

    formUser.setFieldsValue({
      email: user?.email,
      firstname: user?.data?.firstname || "",
      familyname: user?.data?.familyname || "",
      tel: user?.data?.tel || "",
    })

    formDeliveryAddress.setFieldsValue({
      street: user?.data?.street || "",
      zip: user?.data?.zip || "",
      city: user?.data?.city || "",
    })
  }, [user, formUser, isAuthentificated, open, formDeliveryAddress])

  if (!isAuthentificated) return null

  return (
    <div>
      {contextHolder}

      <Drawer
        title={t("menu_title")}
        closeIcon={<ArrowLeftOutlined style={{ fontSize: 20 }} />}
        placement="right"
        onClose={onClose}
        open={open}
      >
        <Typography.Title level={4}>{t("account_settings")}</Typography.Title>

        <Divider />

        <Collapse
          defaultActiveKey={"user"}
          accordion
          items={[
            {
              key: "user",
              forceRender: true,
              label: t("user_information"),
              children: (
                <>
                  <Form
                    form={formUser}
                    layout="vertical"
                    onFinish={async (values) => {
                      try {
                        setState("saving-user")

                        await updateDoc(
                          doc(Firestore, "users", user.uid),
                          values
                        )

                        setUser((prev) => {
                          const u = { ...prev }
                          u.data = { ...u.data, ...values }
                          return u
                        })

                        messageApi.success(t("saved"))
                      } catch (e) {
                        messageApi.error(e.message)
                        console.error(e)
                      } finally {
                        setState("idle")
                      }
                    }}
                  >
                    <Form.Item label={t("email")} name="email">
                      <Input value={user.email} disabled />
                    </Form.Item>

                    <Form.Item
                      label={t("first_name")}
                      name="firstname"
                      rules={[
                        {
                          required: true,
                          message: t("please_enter_data"),
                        },
                      ]}
                    >
                      <Input autoComplete="given-name" />
                    </Form.Item>

                    <Form.Item
                      label={t("last_name")}
                      name="familyname"
                      rules={[
                        {
                          required: true,
                          message: t("please_enter_data"),
                        },
                      ]}
                    >
                      <Input autoComplete="family-name" />
                    </Form.Item>

                    <Form.Item
                      label={t("phone_number")}
                      name="tel"
                      rules={[
                        ({ getFieldValue }) => ({
                          required:
                            true || getFieldValue("type") === "delivery",
                          message: t("please_enter_data"),
                        }),
                      ]}
                    >
                      <Input autoComplete="tel" />
                    </Form.Item>

                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={state === "saving-user"}
                      >
                        Speichern
                      </Button>
                    </Form.Item>
                  </Form>
                </>
              ),
            },
            {
              key: "address",
              label: t("delivery_address"),
              forceRender: true,
              children: (
                <>
                  <Form
                    form={formDeliveryAddress}
                    layout="vertical"
                    onFinish={async (values) => {
                      try {
                        setState("saving-delivery-address")

                        await updateDoc(
                          doc(Firestore, "users", user.uid),
                          values
                        )

                        setUser((prev) => {
                          const u = { ...prev }
                          u.data = { ...u.data, ...values }
                          return u
                        })

                        messageApi.success(t("saved"))
                      } catch (e) {
                        messageApi.error(e.message)
                        console.error(e)
                      } finally {
                        setState("idle")
                      }
                    }}
                  >
                    <Form.Item
                      label={t("street")}
                      name="street"
                      rules={[
                        {
                          required: true,
                          message: t("please_enter_data"),
                        },
                      ]}
                    >
                      <Input autoComplete="address-line1" />
                    </Form.Item>

                    <Form.Item
                      label={t("zip")}
                      name="zip"
                      rules={[
                        {
                          required: true,
                          message: t("please_enter_data"),
                        },
                      ]}
                    >
                      <Input autoComplete="postal-code" />
                    </Form.Item>

                    <Form.Item
                      label={t("city")}
                      name="city"
                      rules={[
                        {
                          required: true,
                          message: t("please_enter_data"),
                        },
                      ]}
                    >
                      <Input autoComplete="address-level2" />
                    </Form.Item>

                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={state === "saving-delivery-address"}
                      >
                        Speichern
                      </Button>
                    </Form.Item>
                  </Form>
                </>
              ),
            },
            // {
            //   key: "order",
            //   label: language === "de" ? "Orders" : "Orders",
            //   children: <></>,
            // },
          ]}
        />
      </Drawer>
    </div>
  )
}

export default MenuDrawerAccount
